<template>
  <div class="stay-my">
    <div class="stay-table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="490"
      >
        <el-table-column
          align="center"
          label="消息内容"
          width="300"
          show-overflow-tooltip
          prop="content"
        >
        </el-table-column>
        <el-table-column prop="smsSubject" label="消息主体">
          <template slot-scope="scope">{{
            scope.row.smsSubject === 1
              ? '企业'
              : scope.row.smsSubject === 2
              ? '专员'
              : ''
          }}</template>
        </el-table-column>
        <el-table-column prop="createBy" label="发送人"> </el-table-column>
        <el-table-column prop="smsType" label="推送渠道">
          <template slot-scope="scope">{{
            smsTypes(scope.row.smsTypes)
          }}</template>
        </el-table-column>
        <el-table-column prop="checkStatus" label="审核状态">
          <template slot-scope="scope">
            <span
              style="
                width: 8px;
                height: 8px;
                display: inline-block;
                border-radius: 50%;
                margin-right:5px;
               background:rgb(73, 194, 105);
              "
            ></span>
            {{ scope.row.checkStatus | statusFilter }}</template
          >
        </el-table-column>
        <el-table-column prop="createTime" label="提交时间"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope"
            ><span class="btn-scope" @click="seeDetails(scope.row)"
              >查看</span
            ></template
          >
        </el-table-column>
      </el-table>
    </div>
    <div class="stay-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="查看"
      :visible.sync="dialogVisible"
      top="100px"
      width="60%"
    >
      <div class="popup_title">
        <div
          :class="{
            title: detailsTitle.checkStatus === 3,
            title_color: detailsTitle.checkStatus === 2,
            title_colors: detailsTitle.checkStatus === 3
          }"
        >
          {{ detailsTitle.checkStatus | statusFilter }}
        </div>
        <div class="ramk">备注：{{ detailsTitle.remark || '-' }}</div>
        <div class="time">
          审核时间：{{ detailsTitle.checkTime || '-' }}
          <span>审核人：{{ detailsTitle.checkMan || '-' }}</span>
        </div>
      </div>

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="其他消息" name="otherMessage"></el-tab-pane>
        <el-tab-pane label="钉钉群消息" name="ddGroupMessage"></el-tab-pane>
      </el-tabs>

      <div v-if="activeName == 'otherMessage'">
        <div class="popup_header">
          <span>发送状态 : </span>
          <el-select
            v-model="sendOut"
            placeholder="请选择发送状态"
            @change="getDetail(channelId)"
            clearable
          >
            <el-option
              v-for="item in IndustryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span>推送渠道 : </span>
          <el-select
            v-model="channel"
            placeholder="请选择推送渠道"
            @change="getDetail(channelId)"
            clearable
          >
            <el-option
              v-for="item in channelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span>是否已读 : </span>
          <el-select
            v-model="isReadValue"
            placeholder="是否已读"
            @change="getDetail(channelId)"
            clearable
          >
            <el-option
              v-for="item in isRead"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="popup_toals">
          共 <b>{{ totalRecords }}</b> 条数据
        </div>

        <el-table
          :data="tableChannel"
          style="width: 100%"
          :header-cell-style="{ background: '#fafafa' }"
          height="490"
        >
          <el-table-column
            prop="entName"
            label="发送企业"
            width="250"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="staffName"
            label="接收人"
            align="center"
          ></el-table-column>
          <el-table-column prop="isRead" label="是否已读" align="center">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.isRead === 0
                    ? '未读'
                    : scope.row.isRead === 1
                    ? '已读'
                    : '-'
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="smsType" label="推送渠道" align="center">
            <template slot-scope="scope">
              <div>
                {{ newChannel[Number(scope.row.smsType)] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="发送状态" align="center">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.status === 0
                    ? '发送失败'
                    : scope.row.status === 1
                    ? '发送成功'
                    : '-'
                }}
              </div>
            </template></el-table-column
          >
        </el-table>
        <div class="table-page">
          <el-pagination
            background
            layout="total,prev, pager, next, sizes, jumper"
            :current-page.sync="currentPages"
            @size-change="handleSizeChanges"
            @current-change="handleCurrentChanges"
            :page-size="pageSizes"
            :total="totalRecords"
          >
          </el-pagination>
        </div>
      </div>

      <dd-sms v-else :channelId="channelId"></dd-sms>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { checkSmsRecordByPage, querySmsRecord } from '@api/video/video'
import ddSms from './ddSms'
export default {
  components: { ddSms },
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalRecord: 0,
      pageSizes: 10,
      currentPages: 1,
      totalRecords: 0,
      dialogVisible: false,
      IndustryList: [
        { value: '', label: '全部' },
        { value: 1, label: '发送成功' },
        { value: 0, label: '发送失败' }
      ],
      tableChannel: [],
      newChannel: {
        0: '手机短信',
        1: '微信公众号',
        2: '站内消息',
        3: '浙政钉消息',
        4: '浙里办消息',
        5: '钉钉群消息'
      },

      sendOut: '',
      // 所有类别数据
      detailsTitle: {
        checkStatus: '',
        remark: '',
        checkTime: '',
        checkMan: ''
      },
      channel: '',
      isReadValue: '',
      channelList: [
        { value: '', label: '全部' },
        { value: 0, label: '手机短信' },
        { value: 1, label: '微信公众号' },
        { value: 2, label: '站内消息' },
        /* { value: 3, label: '浙政钉消息' }, */
        { value: 4, label: '浙里办消息' }
      ],
      isRead: [
        { value: '', label: '全部' },
        { value: 1, label: '已读' },
        { value: 0, label: '未读' }
      ],
      activeName: 'otherMessage',
      channelId: '',
      smsTypeStr: '0,1,2,4' // 区分钉钉群消息和其他消息
    }
  },
  computed: {
    smsTypes() {
      return name => {
        const a = []
        name.map(item => {
          a.push(this.newChannel[item])
        })
        return a.join('，')
      }
    }
  },
  filters: {
    statusFilter(val) {
      let value = ''
      switch (Number(val)) {
        case 1:
          value = '待审核'
          break
        case 2:
          value = '审核驳回'
          break
        case 3:
          value = '审核通过'
          break

        default:
          break
      }
      return value
    },
    smsTypeFilter(val) {
      let value = ''
      switch (Number(val)) {
        case 0:
          value = '手机短信'
          break
        case 1:
          value = '微信公众号'
          break
        case 2:
          value = '站内消息'
          break
        case 3:
          value = '浙政钉消息'
          break
        case 4:
          value = '浙里办消息'
          break
        case 5:
          value = '钉钉群消息'
          break
        default:
          break
      }
      return value
    }
  },
  mounted() {
    this.tabelList()
  },
  methods: {
    // 其他消息和钉钉群消息切换
    handleClick() {
      if (this.activeName == 'otherMessage') {
        this.getDetail(this.channelId)
      }
    },
    // 查看详情
    seeDetails(row) {
      const { checkStatus, remark, checkTime, checkMan } = row
      this.detailsTitle = { checkStatus, remark, checkTime, checkMan }
      this.channelId = row.id
      this.activeName = 'otherMessage'
      this.getDetail(row.id)
    },
    // 查看
    getDetail(id) {
      this.channelId = id
      let par = {
        pageSize: this.pageSizes,
        pageNum: this.currentPages,
        status: this.sendOut,
        smsContentId: id,
        smsType: this.channel,
        smsTypeStr: this.smsTypeStr
      }

      querySmsRecord(par).then(res => {
        if (res.data.code == '0000') {
          let data = res.data.data
          this.tableChannel = data.list || []
          this.totalRecords = data.total || 0
          this.dialogVisible = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    tabelList() {
      const params = {
        title: 2,
        pageNum: this.currentPage,
        pageSize: this.pageSizes
      }
      checkSmsRecordByPage(params).then(res => {
        const { code, data } = res.data
        if (code === '0000') {
          this.tableData = data.results
          this.totalRecord = data.totalRecord
        }
      })
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      console.log(e)
      this.tabelList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.tabelList()
    },
    //  表格翻页
    handleCurrentChanges(currentPage, e) {
      this.currentPages = currentPage
      console.log(e)
      this.getDetail(this.channelId)
    },
    handleSizeChanges(val) {
      this.pageSizes = val
      this.getDetail(this.channelId)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid #e6e6e6;
  }
  .el-dialog__body {
    height: 640px;
    overflow-y: auto;
    font-size: 16px;
    position: relative;
    padding: 15px 20px 30px;
    .popup_title {
      margin-bottom: 20px;
      font-size: 15px;
      border-bottom: 1px solid #e6e6e6;
      > div {
        margin-bottom: 10px;
      }
      .title {
        color: #66cc00;
      }
      .title_color {
        color: #f00;
      }
      span {
        margin-left: 60px;
      }
    }
    .popup_toals {
      font-size: 14px;
      text-align: right;
      margin: 0 10px 10px;
      b {
        font-size: 15px;
        color: #0099ff;
      }
    }
    .popup_header {
      span {
        margin-left: 30px;
      }
    }
    .table-page {
      width: 50%;
      margin: 0 auto;
      // position: absolute;
      // left: 50%;
      // bottom: -20px;
      // transform: translateX(-50%);
    }
    & > div {
      & > div {
        margin-bottom: 20px;
        .texthide {
          width: auto;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap;
        }
        .textshow {
          span {
            width: auto;
          }
        }
        &:nth-child(1) {
          display: flex;
          align-items: center;
          > span {
            display: inline-block;
          }
          span {
            font-size: 14px;
            // color: #1890ff;
          }
        }
      }
    }
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
  }
}
.stay-my {
  .stay-table {
    margin-top: 20px;
  }
  .stay-page {
    margin: 16px;
    text-align: right;
  }
  .btn-scope {
    cursor: pointer;
    color: #1890ff;
  }
}
/deep/.el-tabs__nav-wrap {
  width: 100%;
}
</style>
